import { useAutoneTranslation } from '@autone/translations';

import {
  TailwindSelect,
  TailwindSelectContent,
  TailwindSelectItem,
  TailwindSelectTrigger,
  TailwindSelectValue,
} from '../../../../../tailwind';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

interface AdvancedFiltersFieldSelectProps {
  rowId: string;
}

export const AdvancedFiltersFieldSelect = ({
  rowId,
}: AdvancedFiltersFieldSelectProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch, config } = useAdvancedFiltersContext();

  const { field } = state.conditions[rowId];
  const { fieldOptions } = config;

  const handleUpdateField = (field: string | undefined) => {
    dispatch({
      type: 'PATCH_CONDITION',
      payload: {
        rowId,
        condition: {
          field,
          // always reset value because fields could be incompatible
          value: undefined,
        },
      },
    });
  };

  return (
    <TailwindSelect value={field} onValueChange={handleUpdateField}>
      <TailwindSelectTrigger>
        <TailwindSelectValue placeholder={common('advanced-filters.column')} />
      </TailwindSelectTrigger>
      <TailwindSelectContent data-testId="advanced-filters-column-select-content">
        {Object.entries(fieldOptions).map(([id, translatedDisplayName]) => (
          <TailwindSelectItem key={id} value={id}>
            {translatedDisplayName}
          </TailwindSelectItem>
        ))}
      </TailwindSelectContent>
    </TailwindSelect>
  );
};
